module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/stethoscope-ad3b523a90ca2fcdcb2c28270e5e6265.svg";